import { useState } from 'react';

import { Spin } from 'antd';

import PictureForm from './picture-form';

import TitledCard from '../../../layout-components/titled-card';

const NewPicture: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <TitledCard title="Legendy - Nowe zdjęcie" backUrl="..">
        <PictureForm setLoading={setLoading} />
      </TitledCard>
    </Spin>
  );
};
export default NewPicture;
